module.exports = __webpack_public_path__ + "img/404.b833fa0e.gif";